






















/* Created- 03 - Oct - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { IMetadataArticle } from "../../../Models/ArticleModels/article";
@Component(
	{
		name: "MetadataList"
	})
export default class MetadataList extends Vue {
	@Prop({ default: [] }) private data: IMetadataArticle[]; // your data
	private headers: any = [
		{ text: "Issue", value: "issueId" },
		{ text: "Section", value: "sectionId" },
		{ text: "Title", value: "title" },
		{ text: "Page", value: "pageNumber" },
		{ text: "Abstract", value: "abstract" },
		{ text: "Slug", value: "slug" },
		{ text: "Keywords", value: "keywords" }
	];
}
